module.exports = __webpack_public_path__ + "img/463-a0c5fc.png";